export class OfferContextOperations {
  constructor(
    readonly canUpdate: boolean,
    readonly canDelete: boolean,
    readonly canView: boolean,
    readonly canSharePreview: boolean,
  ) {}
}
